import './contact.scss';

class Contact {
    constructor ($element) {
        this.$form = $element.querySelector('[data-contact="form"]');
        this.$isCustomerWrap = this.$form.querySelector('.iscustomer');
        this.$customerNrWrap = this.$form.querySelector('.customernr');
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        if (this.$isCustomerWrap) {
            const $radios = [].slice.call(this.$isCustomerWrap.querySelectorAll('input[type="radio"]'));
            const $customerNr = this.$customerNrWrap.querySelector('input[type="text"]');

            $radios.forEach((input) => {
                input.addEventListener('change', () => {
                    // Yes
                    if (parseInt(input.value) === 1) {
                        this.$customerNrWrap.classList.add('is--visible');
                        $customerNr.disabled = false;
                    } else if (parseInt(input.value) === 2) { // No
                        this.$customerNrWrap.classList.remove('is--visible');
                        $customerNr.disabled = true;
                    }
                });
            });
        }
    }
}

export { Contact };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $contactPage = $context.querySelector('[data-contact="root"]');

    if ($contactPage) {
        if ($contactPage.querySelector('[data-contact="form"]')) {
            const contact = new Contact($contactPage);
            contact.initialize();
        }
    }
});
